module.exports = "{{ name }}"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/patient-name/patient-name.component.html
// module id = 1202
// module chunks = 0